// @mui
import { Typography, Stack, StackProps } from '@mui/material';
import NoResultsIcon from './NoResultsIcon';
//

// ----------------------------------------------------------------------

interface NoResultsProps extends StackProps {
  title: string;
  img?: string;
  description?: string;
  height?: number;
}

export default function NoResults({ title, description, sx, ...other }: NoResultsProps) {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      sx={{
        height: 1,
        textAlign: 'center',
        px: 2,
        py: 6,
        ...sx,
      }}
      {...other}
    >
      <Stack>
        <NoResultsIcon />
      </Stack>

      <Typography variant="h5" sx={{ mb: 0 }}>
        {title}
      </Typography>

      {description && (
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {description}
        </Typography>
      )}
    </Stack>
  );
}
